// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExampleResponse = {
    ok: (value) => {
        return {
            value: value,
            type: "ok",
            _visit: function (visitor) {
                return FernIr.ExampleResponse._visit(this, visitor);
            },
        };
    },
    error: (value) => {
        return Object.assign(Object.assign({}, value), { type: "error", _visit: function (visitor) {
                return FernIr.ExampleResponse._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "ok":
                return visitor.ok(value.value);
            case "error":
                return visitor.error(value);
            default:
                return visitor._other(value);
        }
    },
};
